/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"

import Header from "../Header/Header";
import "./global.scss";
import "./layout.scss";
import Footer from "../Footer/Footer";

const Layout = ({ children }) => {

  const copyright = '©2024 Delix Therapeutics';
  const links = [
    {
      text: 'Terms',
      url: '/terms/',
      type: 'internal'
    },
    {
      text: 'Policy',
      url: '/policy/',
      type: 'internal'
    },
    {
      text: 'LinkedIn',
      url: 'https://www.linkedin.com/company/delix-therapeutics/',
      type: 'social',
      img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKNSURBVHgB7ZpBbptAFIbfG2iiKIt62SW9QW4QW1H37gninCBFakTxJmRFsCuRniDqCZp9FcXLLt0TmJ6g7s4LZqZvii1ZKQwuqYBp+SSDBQx6P4+Z+efZCEQYTkaM4Tl9PQIzmAPgjee9/Yjr4G/BSITLKPhLMBZ2zmjrgLk4DAzHeAH2LhdJCTPaJojQo94/hBZRIkAmQuCZ71/MNkfCMHQYs+K2CNG+QkLwwXbwCt/3k729Z2dKHLQAnYCZCjbvhOu6S8rAB2gBhQKklF9BgxBqNmweXQaegwFoBOAwCOJeYUMGI2gBhQLUkHl4mObajCh6f0q7U2gBGEVTqb0AYZ6m4gpR0DtvO5Ylj6XEAFpC6URGk9iRZbFPm2RR8NAm/g8r8beh13IphLwjLz/nXPygvDqI2KPPMfzhokorQIj0ZdFkdn09faBA+luHZp53Mci7NgyjgIK9VLM359Idj707KCCzKnYAOw4SNWZA+So+GI/zH8iG9QMbheE0oaG6dLFVSx8g87fIfJU++G3IgwWZC9ZTSwbU4hsqQAKuHr2mv9HqUUg54bIs1D4KKXuyv5+uRxo78X030bdQphL7RWdrzQDN+vHBQfqdOudD9kkXk8lE21EpA1rXW5sAVX+i3ZvHx5UtoRGnX9SuzLbXJmBd+csFUQ6L2/El6O4LNRDHv2y5boZ1oCK1CFitVj3debIQlRdPXWGraToBTdMJaJpOQNN0AprGeAHayhxZWaoypEluQ7Rvt5d7qoLHefo6/062o/w/FAXxhLbaFVnWcLdFm6rgUTlkARV4StuuDzTNPyEgAUNRnZ9xDq34sa4KVBC4se7vP385OXn1jZZ1Dh17AWag/m7zTlX8fgKgodo9eZWvCAAAAABJRU5ErkJggg=="
    },
  ];

  return (
    <>
      <Header />
      <div className="layout">
        <main>{children}</main>
        <Footer copyright={copyright} links={links}/>
      </div>
    </>
  )
}

export default Layout
